import { getBundlesSeats, getPriceBundlePack } from 'src/entities/bundles/model/utils';
import { ID_BUNDLE_ADDITIONAL_SEATS } from 'src/entities/bundles/model/consts';

export const INVOICE_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
];

export const LINE_ITEM_TYPES = {
  SUBSCRIPTION: 'Subscription',
  BUNDLE: 'Add-on',
  // A combo of add-ons sold at a bundle price (bundles_v2), unrelated to BUNDLE above,
  // which is a single add-on and is only called that way in the code.
  BUNDLE_V2: 'Bundle',
  SEATS: 'Seats',
  CUSTOM: 'Custom non-recurring',
};

export const getInitialLineItem = (type, { bundles = [], idsBundlesUser = [] } = {}) => {
  const baseItem = {
    type,
    duration: 1,
    quantity: 1,
    rate: 0,
    amount: 0,
    description: 'RedTrack.io',
    priceIdx: -1,
  };

  switch (type) {
    case LINE_ITEM_TYPES.SUBSCRIPTION:
      return {
        ...baseItem,
        planId: '',
        discount: 0,
        revenue: '',
      };
    case LINE_ITEM_TYPES.BUNDLE:
      return {
        ...baseItem,
        bundleId: '',
        discount: 0,
      };
    case LINE_ITEM_TYPES.BUNDLE_V2:
      return {
        ...baseItem,
        bundleV2Id: '',
        discount: 0,
        // Raw monthly ad-spend value picking the member price tier, not an index. The
        // admin picks it; hasPriceTiers says whether this bundle has any to pick from.
        priceValueFrom: null,
        hasPriceTiers: false,
      };
    case LINE_ITEM_TYPES.SEATS: {
      // Billing sells a client only the seats version it holds,
      // and a client holding none only the one on sale.
      const bundlesSeats = getBundlesSeats(bundles);
      const bundleSeats = bundlesSeats.find(({ id }) => idsBundlesUser.includes(id))
        ?? bundlesSeats.find(({ not_for_sale: isNotForSale }) => !isNotForSale);
      const rate = getPriceBundlePack(bundleSeats, 1);

      return {
        ...baseItem,
        seatsName: 'Additional seats',
        bundleId: bundleSeats?.id ?? ID_BUNDLE_ADDITIONAL_SEATS,
        discount: 0,
        rate,
      };
    }
    case LINE_ITEM_TYPES.CUSTOM:
      return {
        ...baseItem,
        customName: '',
      };
    default:
      return baseItem;
  }
};
